import { useState, useEffect } from 'preact/hooks'

// A tiny island: renders a greeting from config, emits an event up to the
// Component wrapper on click, and listens for a command coming back down.
//
// This is the smallest possible example of the island contract:
//   - `config`  : data passed in from Twig (via the JSON <script> blob)
//   - `bridge`  : the two-way channel injected by core/island.js
//       bridge.emit(event, payload)        island  -> Component wrapper
//       bridge.onCommand(cmd, callback)    Component wrapper -> island
//       bridge.unsetCommand(cmd, callback) remove the listener again
export function AhoyIsland({ bridge, config = {} }) {
	const greeting = config.greeting ?? 'Ahoy!'
	const [count, setCount] = useState(0)
	const [shout, setShout] = useState('')

	// bridge.onCommand: the Component wrapper -> island (downward channel).
	// Always clean up in the effect's return so a remount doesn't stack listeners.
	useEffect(() => {
		const onShout = ({ text }) => setShout(text)
		bridge.onCommand('shout', onShout)
		return () => bridge.unsetCommand('shout', onShout)
	}, [bridge])

	const handleClick = () => {
		const next = count + 1
		setCount(next)
		// bridge.emit: island -> Component wrapper (upward channel)
		bridge.emit('ahoy', { count: next })
	}

	return (
		<div class="ahoy-island">
			<h2>{greeting}</h2>
			<button type="button" onClick={handleClick}>Ahoy! ({count})</button>
			{shout && <p class="ahoy-island__shout">{shout}</p>}
		</div>
	)
}
